import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
} from '@axiom/ui';
import type { Candidate, Opportunity, Position } from '@axiom/validation';

import { OpportunityTalentUtil } from './opportunity-talent-util';

export type OpportunityTalentReassignPositionModalProps = {
  onClose: (candidateId: Candidate['id'] | null) => void;
  isMlRecommendation?: boolean;
  opportunityId: Opportunity['id'];
  candidateId: Candidate['id'];
  positionId?: Position['id'];
};

export const OpportunityTalentReassignPositionModal = ({
  onClose,
  isMlRecommendation = false,
  opportunityId,
  candidateId,
  positionId,
}: OpportunityTalentReassignPositionModalProps) => {
  return (
    <Modal name="REASSIGN_POSITION_MODAL">
      <ModalHeader
        background="blue"
        name="REASSIGN_POSITION_MODAL_HEADER"
        onClose={() => {
          onClose(null);
        }}
      >
        Reassign Position
      </ModalHeader>
      <ModalSection>
        <Paragraph>
          Are you sure you would like to reassign this talent to another
          position? Doing so will impact their current rate, status and
          submission tracker in Axiom for Talent?
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          onClick={() => {
            onClose(null);
          }}
          name="REASSIGN_POSITION_MODAL_CANCEL_BUTTON"
          variation="outline"
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            await OpportunityTalentUtil.reassignPosition({
              opportunityId,
              candidateId,
              positionId,
              isMlRecommendation,
            });
            onClose(candidateId);
          }}
          name="REASSIGN_POSITION_MODAL_SAVE_BUTTON"
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};
